import React, { Component, useContext, useEffect, useState } from 'react'
import { Button } from 'reactstrap'

import { classnames } from '../../utils/classnames'
import { Form, Checkbox, Input, Textarea } from '../partials'
import { ListDropDown } from '../partials/ListDropDown'
import {
  updateFormData
} from '../../api'

import { FieldChoices } from './FieldChoices'
import { JobAppContext } from '../../GlobalState'

export default function Field(props) {

	const { mapped_types, address_types } = useContext(JobAppContext);

	const choices = props.field.choices || ''

	const [ isEditing, setIsEditing ] = useState(props.field.isEditing ? true : false);
	const [ newFld, setNewFld ] = useState(props.field.new || false);
	const [ backup, setBackup ] = useState(props.field);
	const [ deletedChoices, setDeletedChoices ] = useState([]);
	const [ field, setField ] = useState({
		...props.field,
		choices: [...choices]
	});

  	const handleChange = event => {
		const { target } = event
		const { name } = target
		const value = target.type === 'checkbox' ? target.checked : target.value

		setField({
			...field,
			[name]: value
		})
	}

	const addChoice = name => {
		setField({
			...field,
			choices: [
				...field.choices,
				{
					name: name,
					id: 'key_' + (field.choices.length + 1),
				},
			],
		})
	}

  	const handleSubmit = () => {
		setNewFld(false);
		setIsEditing(false);
		setBackup(field);

		updateFormData({
			type: 'field',
			field: field,
			form_id: props.formId,
			deletedChoices: deletedChoices,
		}).then(response => {
			console.log('Field.handleSubmit response', response)

			// setField({ ...response })
			setDeletedChoices([])
		})
	}

	const cancelEdit = () => {
		if (newFld === true) {
			props.removeField(field)
		} else {
			setIsEditing(false);
			setField(backup);
		}
	}

	const handleRemoveField = () => {
		if (newFld === false) {
			if ( confirm('Are you sure you want to delete this field?') ) {
				updateFormData({
					type: 'delete_field',
					field: field,
					form_id: props.formId,
				})
				props.removeField(field)
			}
		} else {
			props.removeField(field)
		}
	}

	const toggleEdit = () => {
		setIsEditing(!isEditing);
		setField(backup);
	}

	const handleRemoveChoice = data => {
		setField({
			...field,
			choices: field.choices.filter(
				(choice, index) => data.id !== choice.id
			),
		});
		setDeletedChoices([
			...deletedChoices, 
			data.id
		]);
	}

	const { index, onDragOver, onDragStart, onDrop, onDragLeave } = props

	const selected_type = (type, type_id) => {
		if ( type == 'address' && type_id != null && type_id > 0 ) {
			var found_type = address_types.find(addr => addr.id == type_id);
			return found_type.id;
		} else {
			return type_id;
		}
	}

	return (
		<div
			className="field"
			// draggable
			// onDragOver={onDragOver}
			// onDragLeave={onDragLeave}
			// onDragStart={onDragStart}
			// onDrop={onDrop}
			id={props.id}
		>
			<div>
				<div className="field_data">
					<div className="field_title">
						{isEditing ? (
							<Input
								autoComplete="off"
								autoFocus={true}
								onChange={handleChange}
								name="title"
								placeholder="Field Title"
								value={field.title}
							/>
						) : (
							<div className="fieldTitleInline" onClick={toggleEdit}>
								<span>name</span>
								{ field.title || backup.title || 'Field Title' }
							</div>
						)}
					</div>

					{field.type !== 'hidden' && (
						<div className="fieldType">
							{isEditing ? (
								<Checkbox
									label="Required"
									name="required"
									value={field.required}
									onChange={handleChange}
								/>
							) : (
								<>
									<span>Required</span>
									<div className="fieldTitleInline" onClick={toggleEdit}>
										{field.required ? 'yes' : 'no'}
									</div>
								</>
							)}
						</div>
					)}

					{field.type == 'text' && field.type_id == null && (
						<div className="fieldType">
							{isEditing ? (
								<>
									<Checkbox
										label="Import with Notes"
										name="add_to_notes"
										value={field.add_to_notes}
										onChange={handleChange}
									/>									
								</>
							) : (
								<>
									<span>Import with Notes</span>
									<div className="fieldTitleInline" onClick={toggleEdit}>
										{field.add_to_notes == 1 ? 'yes' : 'no'}
									</div>
								</>
							)}
						</div>
					)}

					<div className="fieldType">
						<span>type</span>
						{field.type}
					</div>

					{/* field.type === 'hidden' && (
						<div className="field_title">
							{!isEditing && (
								<div className="fieldType">
									<span>Value</span>
									{field.defaultValue}
								</div>
							)}
						</div>
					) */}
				
				</div>

				{/* isEditing && field.type === 'hidden' && (
					<Input
						autoComplete="off"
						className="defaultValue"
						onChange={handleChange}
						name="defaultValue"
						placeholder="Default Value"
						value={field.defaultValue || ''}
					/>
				) */}

				{isEditing && (
					<>
						<Input
							autoComplete="off"
							className="description"
							onChange={handleChange}
							name="description"
							placeholder="Description"
							value={field.description || ''}
						/>
						<ListDropDown
							label="Type ID"
							description='Required for "mapped" and "address" fields'
							className="form-group input-wrapper"
							name="type_id"
							selected={selected_type(field.type, field.type_id)}
							onChange={handleChange}
							items={field.type == 'address' ? address_types : mapped_types}
						/>
						{(field.type === 'choice' || field.type === 'assoc_choice') && (
							<FieldChoices
								choices={field.choices}
								addChoice={addChoice}
								removeChoice={handleRemoveChoice}
							/>
						)}
						<Form className={classnames('fieldOptions')} onSubmit={e => e.preventDefault()}>
							<Button
								color="primary"
								onClick={handleSubmit}
								disabled={!field.title.length}
								className="mr-2"
								type="submit"
							>
								Save
							</Button>
							<Button onClick={cancelEdit}>
								Cancel
							</Button>
						</Form>
					</>
				)}
			</div>
			<div>
				<span className="fa fa-pencil-alt mr-3" onClick={toggleEdit} style={{ cursor: 'pointer' }} />
				<span className="fa fa-trash" onClick={handleRemoveField} style={{ cursor: 'pointer' }} />
			</div>
		</div>
	)
}

